import React from "react";
import PropTypes from "prop-types";
import '../../../../../pages/order/catalogue/cellFragrance/cell-fragrance.scss';
import '../../../../../components/cart/cart.scss';
import WarningIndicator from "components/warning";

const CellCode = ({
  article_code,
  available_from,
  preorder_visible_from,
  tag_promo,
  article_tag,
  article_warning,
  is_out_of_stock,
  out_of_stock_message,
  warningDisplay,
  badgesDisplay,
}) => {
  const tags = tag_promo || [];
  const articleTag = article_tag || '';

  return (
    <td
      colSpan="1"
      className=""
      role="gridcell"
      aria-colindex="5"
      aria-selected="false"
      data-grid-col-index="0"
    >
      <span>{article_code}</span>
      <div className="c-cart-item__badges">
        {articleTag && articleTag.trim() !== '' && (
          <span className="c-cart-item__badge c-cart-item__tag-new">
            {articleTag}
          </span>
        )}
        {tags.map((tag) => {
          return (
            <div style={{marginBottom: '2px'}}>
              <span
                key={tag}
                className="c-cart-item__badge c-cart-item__tag-promo"
              >
                {tag}
              </span>
            </div>
          );
        })}
        {/* Warning articolo come tag/icona secondo config backend b2b.warning_display
            (un flag per tipo: article_warning, out_of_stock) */}
        <WarningIndicator
          value={article_warning}
          config={warningDisplay?.article_warning}
          iconClassName="icon icon-alert"
        />
        <WarningIndicator
          value={is_out_of_stock ? out_of_stock_message : null}
          config={warningDisplay?.out_of_stock}
          iconClassName="icon icon-alert"
        />
      </div>
      {available_from && available_from?.length > 0 && (
        <span className="c-cart-item__badge c-cart-item__available-from">
          {available_from}
        </span>
      )}
      {/* Badge pre-ordine, formato e colori da config('b2b.badges_display'). Il backend
          valorizza preorder_visible_from solo per lo staff. Fallback 'tag' se la config
          non arriva: senza, WarningIndicator userebbe 'both' e mostrerebbe l'icona alert. */}
      <WarningIndicator
        value={preorder_visible_from}
        config={badgesDisplay?.preorder_visible_from ?? 'tag'}
        tagClassName="c-cart-item__badge c-cart-item__preorder-from"
      />
    </td>
  );
};

CellCode.propTypes = {
  article_code: PropTypes.string,
  available_from: PropTypes.string,
  preorder_visible_from: PropTypes.string,
  tag_promo: PropTypes.array,
  article_tag: PropTypes.string,
  article_warning: PropTypes.string,
  is_out_of_stock: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  out_of_stock_message: PropTypes.string,
  warningDisplay: PropTypes.object,
  badgesDisplay: PropTypes.object,
};

export default CellCode;
